export default {
  CURRICULAPLAN_DETAIL: '/api/curriculaPlan/detail',     // 课程详情

  CURRICULAPLAN_PROGRESS: '/api/curriculaSection/progress',     // 获取小节进度

  CURRICULAPLAN_SITUATION: '/api/curriculaPlan/situation',     // 提交进度

  CERTIFICATE_PLACEHOLDERLIST: '/api/contest/certificate/placeholderList',    // 完成课程后查看证书

  CURRICULAPLAN_INFO: '/api/curriculaPlan/curriculaInfo',       // 获取小节详情

  CURRICULAPLAN_CERTIFICATE: '/api/contest/certificate/placeholderList', // 获取证书

  CERTIFICATE_LIST_STUDENTS: '/api/contest/certificate/getCertificateList', // 获取证书列表

  GETCERTIFICATECONBNTESTS: '/api/contest/certificate/getCertificateContests', // 证书赛事列表

  CERTIFICATE_CONTENT: '/api/contest/certificate/content',            // 查看证书

  FILE_GETFILE: '/api/file/getFile',                     // 获取视频内容

  HADNEXERCISE: '/api/exam/practice/handExercise',             // 课程小节进度提交

  ENABLETESTNUM: '/api/exam/practice/enableTestNum',           // 查询可以测评的次数

  CURRICULASECTION_TEST_COMPLETESTATUS: '/api/curriculaSection/test/completeStatus',           // 查询测评完成状态

  CURRICULASECTION_TEST_SUBMMIT: '/api/exam/practice/submit', // 课程测评提交

  CURRICULA_VIDEO_SUMMARY: '/api/curricula/video/summary',                //  AI总结

  CURRICULA_VIDEO_NOTE: '/api/curricula/video/note',                //  AI笔记

  CURRICULA_VIDEO_QUESTION: '/api/curricula/video/question',                //  AI题目

  CURRICULA_VIDEO_TO_CONTENT: '/api/curricula/video/to/content'                //  AI文稿
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/authentication.js